<template>
  <div class="d-flex flex-column justify-start align-center">
    <div class="text-h6 mt-3 ">
      <b>{{ pack.get_default_price() }}€</b> <span style="font-size: 9px;"
        v-if="mainStore.module.metadatas?.exclure_taxe != '1'">
        (+ frais gestion)</span>
      <v-dialog v-if="pack.has_upcoming_majoration()" v-model="showDialog" width="500" max-width="100%"
        scroll-strategy="none">
        <template v-slot:activator="{ props }">
          <v-btn color="darkblue" variant="plain" size="small" v-bind="props"><v-icon icon="mdi-information-outline"
              class="mr-1" size="large"></v-icon> Détails tarif </v-btn>
        </template>

        <v-card>
          <v-card-text>
            <div class="d-flex bg-grey_1 bordered flex-column justify-start px-2 py-1 rounded tarif_pack_item">
              <div class="font-weight-bold"><v-icon icon="mdi-bookmark-outline" color="primary"
                  size="small"></v-icon>Tarif: {{
                    pack.get_default_price() }}€</div>
              <div>
                <div>
                  <div class="text-body-2 text-darkgrey"
                    v-for="(majoration, index_majoration) in pack.get_upcoming_majorations()" :key="index_majoration">
                    <b>{{ majoration.tarif }}€</b> à partir du {{ $moment(majoration.date).format("DD/MM/YYYY") }}
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" block @click="showDialog = false">Fermer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  computed: {
    ...mapStores(useMainStore),
  },
  props: ["pack"],
  data() {
    return {
      showDialog: false,
    };
  },
};
</script>

<style lang="scss" scoped></style>